import { PLK } from '@fe/common/constants/brands'

// Security notice per brand: an entry present = the notice is enabled for that brand.
// To enable another tenant add its entry here and release.
// Every value is spelled out per entry: no fallbacks from `config.company_name`.
export interface SecurityNoticeConfig {
  company: string
  officialChannels: string
  safeChannel: string
  intervalDays: number
}

export const SECURITY_NOTICE_BY_BRAND: Partial<
  Record<string, SecurityNoticeConfig>
> = {
  [PLK]: {
    company: 'Paylinka',
    officialChannels:
      'e-mail (info@paylinka.pl) and the client panel (my.paylinka.pl)',
    safeChannel: 'the client panel',
    intervalDays: 90,
  },
}
